import React from 'react';

import { useMergeLink } from '@mergeapi/react-merge-link';

import type { AdditionalSuccessfulLinkInfo } from '@mergeapi/react-merge-link/dist/types';

type Props = {
  linkToken: string;
  onSuccess: (publicToken: string, additionalInfo?: AdditionalSuccessfulLinkInfo) => void;
  onExit?: () => void;
};

/**
 * This is essentially a wrapper for the Merge Link component. The useMergeLink
 * hook that provides the `open()` function for the Merge Link component
 * requires a `linkToken` as input. Since link tokens should only be fetched
 * when users click the PayrollIntegrationButton, we are put in a situation
 * where we must conditionally invoke a hook, violating the rules of hooks.
 * Thus we have this wrapper that is conditionally rendered when the `linkToken`
 * is fetched (see usage in PayrollIntegrationButton), which calls the
 * `useMergeLink` hook at the top level and conditionally opens the Merge Link
 * component if it is ready (and implicitly, if the link token exists).
 */
export const MergeLink = ({ linkToken, onSuccess, onExit }: Props) => {
  const { open, isReady } = useMergeLink({
    linkToken,
    onSuccess,
    onExit,
  });

  if (isReady) {
    open();
  }

  return <div />;
};
